export default function($) {

  if( $(window).width() >= 1024 ) {
    if( $('.js-spa-card').length ) {
      spaCarousel()
    }
  }

  $(window).resize(function() {
    if( $('.js-spa-card').length ) {
      if ( $(window).width() >= 1024 ) {
        spaCarousel()
      } else {
        $('.js-spa-card').each( function() {
          $(this).css('height', '884px')
        });
      }
    }
  });


  function spaCarousel() {
    moveCards();

    $('.js-spa-card').on('click', function(){
      $('.js-spa-card').removeClass('spa-card-active z-40');

      $(this).addClass('spa-card-active');
      $(this).css({
        'height': '884px',
        'z-index': 40
      });
      moveCards();
    })
  }

  function moveCards() {
    let indexActive = $('.js-spa-card.spa-card-active').index();

    $('.js-spa-card').each( function() {
      if( $(this).index() != 0 ) {
        $(this).addClass('desk:-ml-[310px] wall:-ml-[224px] wide:-ml-[139px]')
      }

      if( !$(this).hasClass('spa-card-active') ) {
        if( $(this).index() == indexActive + 1 || $(this).index() == indexActive - 1 ) {
          $(this).css({
            'height': 'calc(884px - 128px)',
            'z-index': '30'
          })
        } else if( $(this).index() == indexActive + 2 || $(this).index() == indexActive - 2 ) {
          $(this).css({
            'height': 'calc(884px - 256px)',
            'z-index': '20'
          })
        } else {
          $(this).css({
            'height': 'calc(884px - 384px)',
            'z-index': '10'
          })
        }
      }
    })
  }
}
